(function() {
  const FREE_GIFT_VARIANT_ID = '46112138166506';
  const ELIGIBLE_TAG = 'free-gift-eligible';
  let isProcessing = false;
  let debounceTimer = null;
  const tagCache = {};

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function fetchProductTags(handle) {
    if (tagCache[handle] !== undefined) return tagCache[handle];
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    tagCache[handle] = data.tags || [];
    return tagCache[handle];
  }

  async function addFreeGift() {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }]
      })
    });
    if (!res.ok) {
      const err = await res.json();
      console.error('[free-gift] add failed:', err);
    }
  }

  async function removeFreeGift(lineIndex) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });
  }

  async function syncFreeGift() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();
      const lines = cart.items;

      const freeGiftLine = lines.find(item => String(item.variant_id) === FREE_GIFT_VARIANT_ID);
      const freeGiftIndex = freeGiftLine ? lines.indexOf(freeGiftLine) + 1 : null;

      let hasEligibleProduct = false;
      for (const item of lines) {
        if (String(item.variant_id) === FREE_GIFT_VARIANT_ID) continue;
        const tags = await fetchProductTags(item.handle);
        if (tags.includes(ELIGIBLE_TAG)) {
          hasEligibleProduct = true;
          break;
        }
      }

      if (hasEligibleProduct && !freeGiftLine) {
        await addFreeGift();
      } else if (!hasEligibleProduct && freeGiftLine) {
        await removeFreeGift(freeGiftIndex);
      }
    } catch(e) {
      console.error('[free-gift]', e);
    } finally {
      isProcessing = false;
    }
  }

  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGift, 800);
  }

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const result = await originalFetch.apply(this, args);

    const isCartWrite = url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');
    const isFreeGiftWrite = url.includes(FREE_GIFT_VARIANT_ID);

    if (isCartWrite && !isFreeGiftWrite) {
      debouncedSync();
    }

    return result;
  };

  document.addEventListener('cart:updated', debouncedSync);

  // Delay initial sync until after page is fully loaded
  if (document.readyState === 'complete') {
    setTimeout(syncFreeGift, 1000);
  } else {
    window.addEventListener('load', () => setTimeout(syncFreeGift, 1000));
  }
})();
